export const rounding = {
    small: 8,
    large: 20,
};
